export default __webpack_public_path__ + "static/media/lang_ru.c0b928bc.svg";